var map = {
	"./01.jpg": 60670,
	"./01.webp": 61702,
	"./02.jpg": 3753,
	"./02.webp": 25959,
	"./03.jpg": 65708,
	"./03.webp": 72260,
	"./04.jpg": 46903,
	"./04.webp": 71989,
	"./05.jpg": 83066,
	"./05.webp": 26474,
	"./06.jpg": 89317,
	"./06.webp": 19467,
	"./07.jpg": 62152,
	"./07.webp": 79560,
	"./08.jpg": 50291,
	"./08.webp": 49081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62699;